const push_id = JSON.parse(localStorage.getItem('push_id'));

export const initiateSocket = new WebSocket(
  `wss://dev-1.aiti-kace.com.gh:3110/wss/${push_id}`
);

// `ws://dev-1.aiti-kace.com.gh:3110/ws/${push_id}`

// ws / { channel };
